
import { useState } from "react";
import styled from "styled-components";
import { IoIosSave } from "react-icons/io";
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

import GreenButton from "../../../../ui/GreenButton";

import { toast } from 'react-toastify';


const DivGeral = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  padding: 25px;
  box-shadow: 0px 0px 2px #ccc;

`;


const Label = styled.label`
  color: #4f4f4f;
  font-weight: 600;
  font-size: 17px;  
  display: flex;
  flex-direction: column;

  select {
    &.erro {
      border: 2px solid red;
      
    }
  }
`;






const Div = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 5px;
    height: 37px;
  }

`;
const Input = styled.input`

  width: 300px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 

    &.erro {
    border: 2px solid red;
    
  }
`;

const Input1 = styled.input`

  width: 250px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; 

    &.erro {
    border: 2px solid red;
    
  }
`;


const Input2 = styled.input`
  width: auto;
  min-width: 300px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;



const Input5 = styled.input`
  width: auto;
  min-width: 620px;
  height: 200px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /
  &.erro {
      border: 2px solid red;
      
    }
`;
const H2 = styled.h2`
  color: #575757;
`;

const Button = styled.button`
  padding: 10px 30px;
  background-color: transparent;
  color: #575757;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  @media (max-width: 768px) {
    padding: 5px;
    font-size: 14px;
  }
  
`;

const SelectContainer = styled.div`
  .custom-select__control {
    border-radius: 6px;
    padding: 2px 0px;
    height: 35px;
    width: 620px;
    box-shadow: none;
    font-weight: normal;
    &:hover {
      border-color: #888;
    }
    &.erro {
      border: 2px solid red;
    
    }
  }

  .custom-select__menu {
    z-index: 9999; /* Isso garante que fique acima do modal */
  }

  .custom-select__menu-list {
    max-height: 120px; /* ~3 itens */
    overflow-y: auto;
  }

  .custom-select__option {
    padding: 2px 0px;
    color: #575757;
    background-color: #fff;
    font-weight: normal;
  }

  .custom-select__placeholder {
    color: #999;
    font-weight: normal;
  }

  .custom-select__single-value {
    color: #000;
    font-weight: normal;
  }

  .custom-select__control.erro {
    border: 2px solid red;
  }


`;



const Form = ({ urlApi, tipoPosse, tipoEquipamento, setorEquipamento, setAtualizaMateriais, usuarioEquipamento }) => {
  //========================================================TOKEN
  const token = localStorage.getItem('token');


  const [posseSelecionada, setPosseSelecionada] = useState("");
  const [equipamentoSelecionado, setEquipamentoSelecionado] = useState("");
  const [equipamentoAd, setEquipamentoAd] = useState("");
  const [setorEquipamentoSelecionado, setSetorEquipamentoSelecionado] = useState("");
  const [tagEquipamentoSelecionado, setTagEquipamentoSelecionado] = useState("");
  const [marcaModeloEquipamentoSelecionado, setMarcaModeloEquipamentoSelecionado] = useState("");
  const [serieEquipamentoSelecionado, setSerieEquipamentoSelecionado] = useState("");
  const [usuarioEquipamentoSelecionado, setUsuarioEquipamentoSelecionado] = useState("");
  const [dadosUsuarioSelecionado, setDadosUsuarioSelecionado] = useState(null);
  const [numeroContrato, setNumeroContrato] = useState("");
  const [observacao, setObservacao] = useState("");






  //Controla as opções do SITUAÇÂO
  const opcoesSituacao = {
    US: "Em uso",
    MA: "Manutenção",
    BA: "Baixado",
    DISP: "Disponível",
    RES: "Reservado",
    TRANS: "Em transferência",
    INST: "Em instalação/configuração",
    DESC: "Descartado / Obsoleto",
    ROUB: "Roubado / Furtado",
  };
  const [situacao, setSituacao] = useState("");

  //Usuários do SELECT
  const opcoesUsuarios = usuarioEquipamento.map((tipo) => ({
    value: tipo.Cod_Func,
    label: `${tipo.Cod_Func} - ${tipo.Desc_Func} - ${tipo.Desc_Departamento}`,
  }));



  const [erros, setErros] = useState({});

  const salvarEquipamento = async () => {
    if (!token) {
      toast.error('Sessão expirada. Faça login novamente.');
      return;
    }

    if (observacao && observacao.length > 500) {
      setErros({ observacao: true });
      toast.warn('A observação não pode ter mais de 500 caracteres.');
      return;
    }

    const novosErros = {};
    if (!tagEquipamentoSelecionado) novosErros.tag = true;
    if (!posseSelecionada) novosErros.posse = true;
    if (!equipamentoSelecionado) novosErros.equipamento = true;
    if (!usuarioEquipamentoSelecionado) novosErros.usuario = true;
    if (!situacao) novosErros.situacao = true;



    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);
      toast.warn('Preencha todos os campos obrigatórios corretamente.');
      return;
    }

    setErros({});


    try {
      const payload = {
        tipo_posse: posseSelecionada,
        tipo_equipamento: equipamentoSelecionado,
        setor: Number(dadosUsuarioSelecionado.Cod_Departamento),
        objeto_custo: Number(dadosUsuarioSelecionado.Cod_Objeto),
        tag: tagEquipamentoSelecionado,
        marca_modelo: marcaModeloEquipamentoSelecionado,
        numero_serie: serieEquipamentoSelecionado,
        usuario_responsavel: usuarioEquipamentoSelecionado,
        situacao,
        contrato: numeroContrato,
        observacao,
        ad: equipamentoAd,
      };

      const response = await fetch(`${urlApi}central-ti/adicionar-equipamento`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        toast.success(data?.message || 'Equipamento adicionado com sucesso!');
        setAtualizaMateriais(true);

        // limpar formulário se quiser
        // ...
      } else {
        const err = await response.json();
        toast.error(err?.error || 'Erro ao salvar.');
      }
    } catch (error) {
      toast.error(error.message || 'Erro inesperado ao salvar.');
    }
  };







  return (
    <DivGeral>
      <H2>Cadastro de Equipamento</H2>



      <Div>
        <Label>
          Tag do Equipamento:
          <Input1
            className={erros.tag ? 'erro' : ''}
            type="text"
            value={tagEquipamentoSelecionado}
            onChange={(e) => setTagEquipamentoSelecionado(e.target.value)}
            placeholder="Digite a TAG"
          />
        </Label>

        <Label>
          Marca/Modelo:
          <Input2
            type="text"
            value={marcaModeloEquipamentoSelecionado}
            onChange={(e) => setMarcaModeloEquipamentoSelecionado(e.target.value)}
            placeholder="Digite a Marca/Modelo"
          />
        </Label>

        <Label>
          N° de série:
          <Input1
            type="text"
            value={serieEquipamentoSelecionado}
            onChange={(e) => setSerieEquipamentoSelecionado(e.target.value)}
            placeholder="N° de série"
          />
        </Label>


      </Div>

      <Div >
        <Label>
          Tipo de Equipamento:
          <select
            className={erros.equipamento ? 'erro' : ''}
            value={equipamentoSelecionado}
            onChange={(e) => setEquipamentoSelecionado(e.target.value)}
          >
            <option value="" disabled>Selecione o tipo</option>
            {tipoEquipamento.map((tipo) => (
              <option key={tipo.ID_TIPO} value={tipo.ID_TIPO}>
                {tipo.DESC_TIPO_EQUIPAMENTO}
              </option>
            ))}
          </select>
        </Label>
        {(equipamentoSelecionado === "1" || equipamentoSelecionado === "2") && (
          <Label>
            Active Directory:
            <select
              value={equipamentoAd}
              onChange={(e) => setEquipamentoAd(e.target.value)}
            >
              <option value="" disabled>Selecione</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </Label>
        )}


        <Label>
          Situação:
          <select
            name="situacao"
            className={erros.situacao ? 'erro' : ''}
            value={situacao}
            onChange={(e) => setSituacao(e.target.value)}
          >
            <option value="" disabled>Escolha...</option>
            {Object.entries(opcoesSituacao).map(([valor, label]) => (
              <option key={valor} value={valor}>{label}</option>
            ))}
          </select>
        </Label>
      </Div>

      <Div >

        <Label>
          Tipo de Posse:
          <select
            className={erros.posse ? 'erro' : ''}
            value={posseSelecionada}
            onChange={(e) => setPosseSelecionada(e.target.value)}
          >
            <option value="" disabled>Selecione o tipo</option>
            {tipoPosse.map((tipo) => (
              <option key={tipo.ID_TIPO} value={tipo.ID_TIPO}>
                {tipo.DESC_TIPO_POSSE}
              </option>
            ))}
          </select>
        </Label>

        <Label>
          N° do contrato:
          <Input1
            type="text"
            value={numeroContrato}
            onChange={(e) => setNumeroContrato(e.target.value)}
          />
        </Label>



      </Div>

      <Div>
        <Label>
          Usuário Responsável:
          <SelectContainer>
            <Select
              classNamePrefix="custom-select"
              options={opcoesUsuarios}
              value={opcoesUsuarios.find(opt => opt.value === usuarioEquipamentoSelecionado)}
              onChange={(selected) => {
                const codFunc = selected?.value || '';
                setUsuarioEquipamentoSelecionado(codFunc);

                const usuarioSelecionado = usuarioEquipamento.find(u => u.Cod_Func === codFunc);
                setDadosUsuarioSelecionado(usuarioSelecionado || null);
              }}
              placeholder="Selecione o usuário"
              isClearable
              styles={{
                control: (base, state) => ({
                  ...base,
                  border: erros.usuario ? '2px solid red' : '1px solid #ccc',
                  boxShadow: 'none',
                  minHeight: '37px',
                }),
              }}
            />


          </SelectContainer>


        </Label>

      </Div>

      <Div>

        <Label>
          Departamento
          <Input
            type="text"
            value={dadosUsuarioSelecionado?.Desc_Departamento || ''}
            readOnly
            placeholder="Departamento"
            disabled
          />
        </Label>
        <Label>
          Objeto de Custo
          <Input
            type="text"
            value={dadosUsuarioSelecionado?.Desc_ObjetoCusto || ''}
            readOnly
            placeholder="Objeto de Custo"
            disabled
          />
        </Label>


      </Div>

      <Div>


        <Label>
          Observação:
          <Input5
            type="text"
            className={erros.observacao ? 'erro' : ''}
            placeholder="Digite uma observação"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
          />


        </Label>
      </Div>

      <Div>
        <GreenButton onClick={salvarEquipamento}>
          Salvar Equipamento
        </GreenButton>

      </Div>

      <style jsx global>{`
        .swal2-container.custom-swal-container {
          z-index: 9999;
        }
      `}</style>
    </DivGeral>
  );
};

export default Form;




